<button class="tw-menu-item" [ngClass]="{ 'tw-menu-item--dense': dense }" [style.text-align]="textAlign ?? ''">
  <ng-content></ng-content>
</button>
